import { createFileRoute } from "@tanstack/react-router";
import { ContentPage, ContentProse } from "@/components/content-page";
import { seo } from "@/lib/seo";
import { breadcrumb, webPage } from "@/lib/structured-data";
import { SITE_URL } from "@/lib/seo-constants";

export const Route = createFileRoute("/terms")({
  head: () =>
    seo({
      title: "Terms of Service Agreement & Usage Policy",
      description:
        "The terms that govern your use of Axy.digital, the autonomous algorithmic marketing engine by Auxetic Studio.",
      path: "/terms",
      type: "website",
      jsonLd: [
        webPage({
          name: "Terms of Service — Axy.digital",
          description:
            "The terms that govern your use of Axy.digital, the autonomous algorithmic marketing engine by Auxetic Studio.",
          url: `${SITE_URL}/terms`,
        }),
        breadcrumb([
          { name: "Home", url: "/" },
          { name: "Terms of Service", url: "/terms" },
        ]),
      ],
    }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <ContentPage
      eyebrow="Legal"
      title={
        <>
          Terms of <span className="text-gradient">Service</span>
        </>
      }
      description="The terms that govern your use of Axy.digital, the autonomous algorithmic marketing engine by Auxetic Studio."
    >
      <ContentProse>
        <p>Last updated: July 8, 2026.</p>

        <h2>Using Axy.digital</h2>
        <p>
          By creating an account or using Axy.digital, you agree to these terms. You are responsible
          for the content you connect to the engine and for complying with the policies of the
          channels you publish to.
        </p>

        <h2>Subscriptions and billing</h2>
        <p>
          Paid plans are billed monthly in advance and renew automatically until cancelled. You can
          cancel any time from your account; access continues to the end of the current billing
          period.
        </p>

        <h2>Acceptable use</h2>
        <p>
          Don't use Axy.digital to generate spam, infringing material, or anything that violates
          applicable laws. We may suspend accounts that abuse the service.
        </p>

        <h2>Intellectual property</h2>
        <p>
          You own the content you input and the marketing outputs Axy.digital generates for you. We
          retain ownership of the platform itself.
        </p>

        <h2>Disclaimers</h2>
        <p>
          Axy.digital is provided "as is". We do not guarantee specific marketing outcomes. To the
          maximum extent permitted by law, our liability is limited to the fees paid in the prior
          twelve months.
        </p>

        <h2>Contact</h2>
        <p>
          Auxetic Studio · <a href="mailto:legal@axy.digital">legal@axy.digital</a>
        </p>
      </ContentProse>
    </ContentPage>
  );
}
